module.exports = __webpack_public_path__ + "static/media/shredder.a109bf31.svg";